export default "__VITE_ASSET__C93qSvMG__"